import { ContentHeader } from 'themes/jumbo/app/_components/_core';
import {useEffect, useState} from 'react';
import { ASSET_AVATARS } from 'themes/jumbo/app/_utilities/constants/paths';
import { getAssetPath } from 'themes/jumbo/app/_utilities/helpers';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAccount, useMsal } from "@azure/msal-react";
import { capitalize } from 'services/UtilsService';
import {
  Avatar,
  Button,
  Divider,
  List,
  MenuItem,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import React from 'react';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(0, 1),

  '&:hover': {
    backgroundColor: 'transparent',
  },

  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}));

const Item = styled('div')({
  textAlign: 'center',
});



const ProfileHeader = (props:any) => {
  const {users, maxUsers} = props
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [userName, setUserName] = useState("Guest");
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    if (account && account.name) {
		console.log("Accout name : " + account.name)
		const userAccount = account.name.split(" ")
		if(userAccount.length > 1)
			setUserName(capitalize(account.name.split(" ")[0]) + " " + capitalize(account.name.split(" ")[1]));
		else
			setUserName(capitalize(account.name));
			
		setUserEmail(account.username);

    } else {
        setUserName("Guest");
        setUserEmail("");
    }
  }, [account, instance]);

  return (
    <ContentHeader
      avatar={
        <Avatar
          sx={{ width: { xs: 48, sm: 72 }, height: { xs: 48, sm: 72 } }}
          alt={userName}
          src={getAssetPath(`${ASSET_AVATARS}/avatar3.jpg`, '72x72')}
        />
      }
      title={
        <Typography fontSize={18} variant={'body1'} color={'inherit'}>
          {userName}
        </Typography>
      }
      subheader={
        <Typography fontSize={12} variant={'body1'} color={'inherit'} mt={0.5}>
          {userEmail}
        </Typography>
      }
      tabs={
        <List
          disablePadding
          sx={{
            display: 'flex',
            minWidth: 0,
          }}
        >
        </List>
      }
      action={
        <Button
          // disableRipple
          // variant='text'
          // startIcon={<SettingsIcon />}
          // sx={{
          //   color: 'inherit',
          //   textTransform: 'none',
          //   '&:hover': {
          //     backgroundColor: 'transparent',
          //   },
          // }}
        >
          {/* Settings */}
        </Button>
      }
      sx={{
        position: 'relative',
        zIndex: 1,
        maxWidth: 1320,
        marginInline: 'auto',

        '& .MuiCardHeader-action': {
          alignSelf: 'center',
          margin: 0,
        },
      }}
    >
        <Stack
            direction={'row'}
            justifyContent={'space-evenly'}
            divider={<Divider orientation='vertical' flexItem />}
            spacing={2}
            sx={{
            mx: 1,
            }}
        >
            <Item>
                <Typography variant={'h6'} color={'inherit'} mb={0}>
                    {maxUsers}
                </Typography>
                <Typography variant={'body1'} fontSize={12}>
                    Max Users
                </Typography>
            </Item>
            {users > 0 ? 

            <Item>
                <Typography variant={'h6'} color={'inherit'} mb={0}>
                    {users}
                </Typography>
                <Typography variant={'body1'} fontSize={12}>
                Active Users
                </Typography>
            </Item>
            :
            ''
            }
        </Stack>
    </ContentHeader>
  );
};

export { ProfileHeader };
